export default "__VITE_ASSET__9aecea36__"